/* @refresh reload */
import { render } from "solid-js/web";
import App from "./App";
import "./index.css";
import { initTelegram } from "./lib/telegram";
import { installAudioUnlocker } from "./lib/sound";
import { installPerf } from "./lib/perf";

initTelegram();
installAudioUnlocker();
installPerf();

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");
render(() => <App />, root);
